import Vue from "vue";
import VueCookie from "vue-cookie";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import CountryFlag from "vue-country-flag";
import i18n from "./i18n";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store";
import Vddl from "vddl";

Vue.use(Vddl);
Vue.use(store);
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.use(VueCookie);
Vue.use(require("vue-moment"));
Vue.component("country-flag", CountryFlag);
new Vue({
  el: "#app",
  router,
  vuetify,
  i18n,
  store,
  icons: {
    iconfont: "mdi",
  },
  render: (h) => h(App),
});

// 5fjNo3PLyuhjcyMkEQiIIVlw7wgwXqDabSdN0LjGIQEUDysP6zoiXb16QK9VSQZ64TAiWSIWotAZqtyhvDfzvOKh3kt2lpqmHowVFh8ytpM2ipUTb422qZAkCFGyYkgC
